import React from 'react';

const PricingSection = () => {
  return (
    <section id="pricing" className="py-16 bg-gradient-to-r from-blue-200 to-blue-600">
      {/* Section Title */}
      <div className="container mx-auto text-center mb-16" data-aos="fade-up">
        <h2 className="text-4xl font-semibold text-white">Pricing</h2>
        <p className="text-lg text-white opacity-70">Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>

      <div className="container mx-auto px-4">
        {/* Grid for desktop view */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          
          {/* Free Plan */}
          <div className="w-full" data-aos="zoom-in" data-aos-delay="100">
            <div className="bg-white p-8 shadow-lg rounded-lg h-full relative">
              <h3 className="text-2xl font-semibold mb-4">Free Plan</h3>
              <h4 className="text-5xl text-blue-600 font-light mb-6">
                <sup className="text-3xl">$</sup>0<span className="text-lg"> / month</span>
              </h4>
              <ul className="text-gray-600 text-lg mb-6">
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Quam adipiscing vitae proin</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Nec feugiat nisl pretium</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Nulla at volutpat diam uteera</li>
                <li className="flex items-center text-gray-400 mb-4"><i className="text-gray-400 mr-2">✘</i> Pharetra massa massa ultricies</li>
                <li className="flex items-center text-gray-400 mb-4"><i className="text-gray-400 mr-2">✘</i> Massa ultricies mi quis hendrerit</li>
              </ul>
              <div className="text-center">
                <a href="#" className="inline-block px-8 py-3 bg-gray-800 text-white rounded-lg border border-gray-400 hover:bg-blue-600 hover:border-blue-600 transition duration-300">Buy Now</a>
              </div>
            </div>
          </div>

          {/* Business Plan (Featured) */}
          <div className="w-full" data-aos="zoom-in" data-aos-delay="200">
            <div className="bg-blue-600 text-white p-8 shadow-lg rounded-lg h-full relative z-10">
              <h3 className="text-2xl font-semibold mb-4">Business Plan</h3>
              <h4 className="text-5xl font-light mb-6">
                <sup className="text-3xl">$</sup>29<span className="text-lg"> / month</span>
              </h4>
              <ul className="text-white text-lg mb-6">
                <li className="flex items-center mb-4"><i className="text-white mr-2">✔</i> Quam adipiscing vitae proin</li>
                <li className="flex items-center mb-4"><i className="text-white mr-2">✔</i> Nec feugiat nisl pretium</li>
                <li className="flex items-center mb-4"><i className="text-white mr-2">✔</i> Nulla at volutpat diam uteera</li>
                <li className="flex items-center mb-4"><i className="text-white mr-2">✔</i> Pharetra massa massa ultricies</li>
                <li className="flex items-center mb-4"><i className="text-white mr-2">✔</i> Massa ultricies mi quis hendrerit</li>
              </ul>
              <div className="text-center">
                <a href="#" className="inline-block px-8 py-3 bg-blue-600 text-white rounded-lg border border-white hover:bg-white hover:text-blue-600 hover:border-blue-600 transition duration-300">Buy Now</a>
              </div>
            </div>
          </div>

          {/* Developer Plan */}
          <div className="w-full" data-aos="zoom-in" data-aos-delay="100">
            <div className="bg-white p-8 shadow-lg rounded-lg h-full relative">
              <h3 className="text-2xl font-semibold mb-4">Developer Plan</h3>
              <h4 className="text-5xl text-blue-600 font-light mb-6">
                <sup className="text-3xl">$</sup>49<span className="text-lg"> / month</span>
              </h4>
              <ul className="text-gray-600 text-lg mb-6">
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Quam adipiscing vitae proin</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Nec feugiat nisl pretium</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Nulla at volutpat diam uteera</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Pharetra massa massa ultricies</li>
                <li className="flex items-center mb-4"><i className="text-green-500 mr-2">✔</i> Massa ultricies mi quis hendrerit</li>
              </ul>
              <div className="text-center">
                <a href="#" className="inline-block px-8 py-3 bg-gray-800 text-white rounded-lg border border-gray-400 hover:bg-blue-600 hover:border-blue-600 transition duration-300">Buy Now</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PricingSection;
